module.exports = __webpack_public_path__ + "static/media/sidebar-1.6be21e8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-1.jpg
// module id = 896
// module chunks = 0